module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_DE-c76d0eb9f67f7f674c3315d6fc5d29b4.svg";